<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <el-form-item label="短信主题" prop="smsTheme">
            <el-input class="form-input" v-model="searchForm.smsTheme" clearable></el-input>
          </el-form-item>
          <el-form-item label="创建人" prop="createdBy">
            <el-input class="form-input" v-model="searchForm.createdBy" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" clearable @change="onSearch">
              <el-option v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" prop="updatedTime">
            <q-date-picker startFiled="startDate" endFiled="endDate" v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="newAddMessage">新增发送</el-button>
        <el-button type="primary" size="small" @click="handleExport">导出明细</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        border
        highlight-current-row
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column prop="smsTheme" label="短信主题"  show-overflow-tooltip width="160"></el-table-column>
        <el-table-column prop="content" label="短信内容" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="createdByName" label="创建人"  show-overflow-tooltip align="center" width="120"></el-table-column>
        <el-table-column prop="pushDate" label="推送时间"  width="160" align="center">
          <template slot-scope="scope">
            {{scope.row.pushDate | dateFormat}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="rollingStatus" label="进度"  align="center">
          <template slot-scope="scope">
            <el-progress :percentage="50" :format="format"></el-progress>
          </template>
        </el-table-column> -->
        <el-table-column prop="rollingStatus" label="成功/失败" width="100" align="center">
          <template slot-scope="scope">
            {{`${scope.row.successNumber} / ${scope.row.failNumber}`}}
          </template>
        </el-table-column>
         <el-table-column prop="rollingStatus" label="状态" width="80"  align="center">
          <template slot-scope="scope">
            {{scope.row.status | statusEnum}}
          </template>
        </el-table-column>
        <el-table-column  label="操作"  class-name="action-column" align="center" width="150">
          <template v-slot="scope">
            <el-button  type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <el-button  type="text" v-if="scope.row.status == 'waiting'" size="small" @click="handleStop(scope.row)">停止计划</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin'
import pagePathMixin from '@/utils/page-path-mixin'
import { downloadFile } from '@/utils/downloadFile.js'
export default {
  mixins: [tableMixin,pagePathMixin],
  name: 'messageList',
  data () {
    return {
      searchForm: {
        smsTheme: '',
        createdBy: '',
        status: '',
        startDate: '',
        endDate: '',
      },

      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      stateList: [
        { value: '', label: '全部' },
        { value: 'waiting', label: '待推送' },
        { value: 'pushing', label: '推送中' },
        { value: 'finish', label: '推送完成' },
        { value: 'stop', label: '推送停止' },
        { value: 'fail', label: '推送失败' },
      ],
    }
  },
  methods: {
    init () {
      this.onSearch()
    },
    getList () {
      this.loading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam
        }
      }
      this.$api.message.queryBatchPushList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || []
          this.total = total
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSizeChange (pageSize) {
      this.pageSize = pageSize
      // 切换每页条数后从第一页查询
      this.pageNum = 1
      this.getList()
    },
    onNumChange (pageNum) {
      this.pageNum = pageNum
      this.getList()
    },
    resetSearchForm () {
      this.$refs.searchForm.resetFields()
      this.initDate()
      this.filterParam = {}
      this.onSearch()
    },
    onSearch () {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {}
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val
        }
      }
      this.pageNum = 1
      this.getList()
    },
    initDate() {
      this.searchForm.startDate = '',
      this.searchForm.endDate = '',
      this.$refs.dateRef.reset()
    },
    newAddMessage() {
      this.openSubPage({
        path: '/content/add-message',
      })
    },
    handleDetail(row) {
      this.openSubPage({
        path: '/content/add-message',
        query: {
          isDetail: true,
          pushId: row.pushId
        }
      })
    },
    handleStop(row) {
      this.$confirm('停止后将无法恢复。请问是否停止？', '提示', {
        confirmButtonText: '确定 ',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.message.stopPush(row.pushId).then(res => {
          if (res.success) {
            this.$notify.success('停止成功');
            this.getList()
          }
        })
      })
     
    },
    handleExport() {
      let params = {
        ...this.filterParam
      };
        this.$api.common.doExport('queryBatchPushList', params).then(() => {
          this.$message.success('导出操作成功，请前往导出记录查看详情');
      });
    },
    download () {
      downloadFile('https://tactivity.quanyou.com.cn/group1/M00/06/BB/rB8kQmMHKUaAKZozAAAxT0y57sw35.xlsx','题库模版',)
    }
  },
  filters: {
    statusEnum (val) {
      let map = {
        waiting: '待推送',
        pushing: '推送中',
        finish: '推送完成',
        stop: '推送停止'
      }
      return map[val]
    },
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
 .date-input {
    width 130px !important
  }
  .to {
    display: inline-block;
    margin: 0 4px;
  }
</style>
